import { render, staticRenderFns } from "./category-tile.vue?vue&type=template&id=59e56f22&"
import script from "./category-tile.vue?vue&type=script&lang=js&"
export * from "./category-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports